<script>
import { Bar } from "vue-chartjs";
import pluginConfig from "../../services/graphPlugins.js";

export default {
  extends: Bar,
  props: {
    args: { type: Object, required: true }
  },
  data() {
    return {
      feedIndex: 0,
      highestValue: 0
    };
  },
  watch: {
    args: {
      async handler() {
        await this.renderGraph();
      }
    }
  },
  async mounted() {
    await this.addPlugin(pluginConfig.labelOutside(this._data._chart));
    await this.renderGraph();
  },
  methods: {
    calculateScale() {
      const allValues = [].concat(...this.args.datasets.map(set => set.values));
      return Math.max(...allValues) * 1.4;
    },
    graphData() {
      return {
        labels: this.args.labels,
        datasets: this.args.datasets.map(set => ({
          label: set.label || this.args.labelPrefix || "",
          backgroundColor: set.color || "blue",
          borderWidth: 2,
          pointBorderWidth: 1,
          pointRadius: 1,
          pointHoverRadius: 5,
          pointHitRadius: 10,
          data: set.values,
          lineTension: 0.2,
          hoverBackgroundColor: set.color || "blue"
        }))
      };
    },
    renderGraph() {
      const context = this;
      this.renderChart(this.graphData(), {
        animation: false,
        tooltips: {
          yAlign: "bottom",
          xAlign: "center",
          displayColors: false,
          bodyFontColor: "black",
          bodyFontSize: 12,
          bodyFontStyle: "bold",
          backgroundColor: "transparent",
          caretSize: 0,
          callbacks: {
            afterBody(tooltipItem) {
              // the click event returns incorrect index so we add it on the hover event
              context.feedIndex = tooltipItem[0].datasetIndex;
            },
            label(ti, data) {
              const unit = data.datasets[ti.datasetIndex].data[ti.index];
              return unit;
            },
            labelTextColor(ti) {
              if (context.args.datasets.length < 2) {
                return context.args.datasets[ti.datasetIndex].color[ti.index];
              }
              return context.args.datasets[ti.datasetIndex].color;
            },
            title() {
              return;
            }
          }
        },
        hover: {
          onHover: (e, el) => {
            e.target.style.cursor = el[0] ? "pointer" : "default";
          }
        },
        legend: {
          display: true,
          labels: {
            usePointStyle: true
          },
          position: "top",
          onClick: () => ({})
        },
        layout: { padding: { top: 0 } },
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                autoSkip: false,
                suggestedMax: this.args.scale || this.calculateScale(),
                suggestedMin: 0,
                callback(value) {
                  return value + context.args.unit;
                }
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        onClick: (_, arr) => {
          this.$nextTick(() => {
            if (arr.length && !isNaN(arr[0]._index)) {
              this.$emit(
                "onDataClick",
                arr[0],
                this.feedIndex,
                this.args.labels[arr[0]._index],
                this.args.meta
              );
            }
          });
        }
      });
    }
  }
};
</script>
